module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-008.e6fc120e.webp";